{
  "errorScreen": {
    "unavailableTitle": "This canvas is unavailable",
    "privateTitle": "This canvas is private or unavailable",
    "privateMessage": "Log in to check whether you have access, or ask the owner to share it with you.",
    "logIn": "Log in / Create account",
    "backToCanvases": "Back to my canvases"
  },
  "compactFrameDelete": {
    "title": "Delete compact frame?",
    "description_one": "{{count}} hidden node inside will be deleted too. You can undo this, or restore it from the trash.",
    "description_other": "{{count}} hidden nodes inside will be deleted too. You can undo this, or restore them from the trash."
  },
  "deleteCanvas": {
    "title": "Delete canvas?",
    "description": "“{{name}}” will be permanently deleted. Its blocks and conversations go with it. This action cannot be undone."
  },
  "dropOverlay": {
    "hint": "Drop to create a node"
  },
  "canvasForm": {
    "updated": "Workspace “{{name}}” updated",
    "created": "Workspace “{{name}}” created",
    "updateFailed": "Error while updating the workspace.",
    "createFailed": "Error while creating the workspace.",
    "editTitle": "Edit workspace",
    "createTitle": "Create a workspace",
    "editDescription": "Update the name, icon, description and look.",
    "createDescription": "Give this new workspace a name.",
    "nameLabel": "Workspace name",
    "namePlaceholder": "Canvas name",
    "nameRequired": "Name cannot be empty",
    "descriptionLabel": "Description (optional)",
    "descriptionPlaceholder": "Canvas description. Helps the assistant understand the context of the canvas.",
    "coverTitle": "Cover image (optional)",
    "coverHint": "Shown on the canvas card on the home page.",
    "backgroundTitle": "Background (optional)",
    "resetBackground": "Reset to default",
    "loadingBackground": "Loading background…",
    "creating": "Creating…"
  },
  "trash": {
    "title": "Trash",
    "description_one": "Deleted blocks are kept for {{count}} day, then deleted for good. Restoring one brings back its content and the connections that went with it.",
    "description_other": "Deleted blocks are kept for {{count}} days, then deleted for good. Restoring one brings back its content and the connections that went with it.",
    "empty": "Nothing in the trash.",
    "restoreFailed": "Could not restore this block",
    "deleteFailed": "Could not delete this block",
    "deletedAgo": "Deleted {{ago}}",
    "deleted": "Deleted",
    "contentGone": "content already deleted",
    "restore": "Restore",
    "deleteForeverConfirm": "Delete forever?",
    "deleteForeverContainer": "“{{title}}” and everything inside it will be deleted for good. This can't be undone.",
    "deleteForeverNode": "“{{title}}” will be deleted for good. This can't be undone.",
    "deleteForever": "Delete forever"
  },
  "status": {
    "synced": "Synced",
    "syncError": "Sync error"
  },
  "sharing": {
    "title": "Share canvas",
    "share": "Share",
    "sharing": "Sharing…",
    "nowPublic": "Canvas is now public.",
    "nowPrivate": "Canvas is now private.",
    "visibilityFailed": "Failed to update canvas visibility",
    "linkCopied": "Link copied to clipboard",
    "copyFailed": "Failed to copy link",
    "publicLink": "Public link",
    "publicLinkHint": "Anyone with the link can view this canvas.",
    "copyLink": "Copy link",
    "notReady": "The canvas is not ready yet.",
    "viewLinkCopied": "Link to this view copied to clipboard",
    "viewLink": "Link to this view",
    "viewLinkHint": "Opens the canvas framed exactly as you see it now.",
    "shareFailed": "Failed to share canvas",
    "emailPlaceholder": "user@example.com",
    "permission": "Permission",
    "roles": {
      "viewer": "Viewer",
      "editor": "Editor"
    },
    "removeFailed": "Failed to remove share",
    "sharedWith": "Shared with",
    "removeAccess": "Remove access"
  },
  "sandbox": {
    "title": "Nolë's computer",
    "ariaLabel": "Nolë's computer: {{status}}",
    "starting": "Starting…",
    "startingTooltip": "Nolë's computer is starting…",
    "turningOff": "Turning off…",
    "turningOffTooltip": "Nolë's computer is turning off…",
    "workingForYouIn": "Working for you, in “{{conversation}}”",
    "workingForYouVia": "Working for you, via “{{via}}”",
    "workingForYou": "Working for you",
    "workingFor": "Working for {{name}}",
    "workingForSomeone": "Working for someone else on this canvas",
    "workingTooltip": "Nolë is using her computer",
    "onFor": "On for {{since}}",
    "onTooltip": "Nolë's computer is on",
    "turnOffFailed": "Could not turn off Nolë's computer",
    "whatItIs": "A computer in the cloud that Nolë uses for this canvas, to analyze data, convert files or run calculations.",
    "lastUsed": "Last used {{ago}}.",
    "turnsOff": "It turns itself off a few minutes after Nolë is done.",
    "websites": "Websites it can visit",
    "turnOffNow": "Turn off now",
    "turnOffLater": "You can turn it off once Nolë is done with it. Nothing is lost: its files are kept, and it turns back on when Nolë needs it.",
    "nothingLost": "Nothing is lost: its files are kept, and it turns back on when Nolë needs it."
  },
  "authBanner": {
    "message": "<strong>Viewing a public canvas.</strong> Log in to duplicate, edit, and keep your own workspaces.",
    "logIn": "Log in<wide> / Create account</wide>",
    "dismiss": "Dismiss"
  },
  "taskPills": {
    "deletedNode": "Deleted node",
    "goTo": "Go to “{{title}}”"
  },
  "history": {
    "undoTitle": "Undo (Ctrl+Z)",
    "redo": "Redo",
    "redoTitle": "Redo (Ctrl+Shift+Z)"
  },
  "bookmarks": {
    "title": "Bookmarks",
    "dangling": "This target is no longer on the canvas",
    "nodeRowTitle": "{{label}} — click to go to, {{modifier}}+click to open",
    "reorder": "Reorder bookmark",
    "remove": "Remove bookmark",
    "empty": "No bookmarks yet. Right-click a node, a selection or the canvas to add one."
  },
  "dockList": {
    "close": "Close {{title}}"
  },
  "toolbar": {
    "tool": "Canvas tool",
    "select": "Select tool",
    "selectTitle": "Select, move and lasso",
    "hand": "Hand tool",
    "handTitle": "Hand: drag to pan the canvas",
    "frame": "Draw a frame",
    "frameTitle": "Draw a frame to group nodes (F)",
    "addBlock": "Add a block",
    "searchTitle": "Search this canvas or jump to another"
  },
  "search": {
    "description": "Search nodes, documents and canvas contents.",
    "placeholderTitles": "Search titles — \"exact phrase\", -exclude, a OR b",
    "placeholderSemantic": "Semantic search — describe the idea in your own words",
    "placeholder": "Search — \"exact phrase\", -exclude, a OR b",
    "clear": "Clear search",
    "hidePreview": "Hide preview",
    "showPreview": "Show preview",
    "titlesOnlyHint": "Only match titles",
    "keywordOnly": "Available in Keyword mode only",
    "titlesOnly": "Titles only",
    "searching": "Searching",
    "results_one": "{{count}} result",
    "results_other": "{{count}} results",
    "resultsLabel": "Search results",
    "noResults": "No results",
    "noMatchesFiltered": "No matches for “{{query}}” with these filters.",
    "noMatches": "No matches for “{{query}}”.",
    "relaxed": "No exact results — showing close matches.",
    "noRecentFiltered": "No recent nodes match these filters",
    "noNodes": "No nodes yet",
    "recent": "Recent",
    "footer": {
      "navigate": "navigate",
      "goTo": "go to",
      "openWindow": "open window",
      "attach": "<kbd>Alt</kbd>+click to attach to Nolë",
      "close": "close"
    },
    "rowDetach": "Alt+click to detach from Nolë",
    "rowAttach": "Alt+click to attach to Nolë"
  },
  "preview": {
    "hover": "Hover a result to preview it.",
    "navigate": "Navigate to node",
    "openWindow": "Open in a window",
    "edited": "Edited {{ago}}",
    "notLoaded": "Content not loaded.",
    "titleOnCanvas": "Title on the canvas.",
    "emptyTitle": "Empty title.",
    "none": "No preview for this node.",
    "emptyDocument": "Empty document.",
    "rows_one": "{{count}} row",
    "rows_other": "{{count}} rows",
    "columns_one": "{{count}} column",
    "columns_other": "{{count}} columns",
    "noImage": "No image.",
    "image": "Image",
    "noLink": "No link.",
    "noFile": "No file.",
    "page": "Page",
    "pageNumber": "Page {{page}}",
    "noVideo": "No video.",
    "videoUnavailable": "Video unavailable.",
    "noAudio": "No audio.",
    "noValue": "No value.",
    "yes": "Yes",
    "no": "No",
    "emptyApp": "Empty app.",
    "appSource_one": "Source · {{count}} line — open the window to run it",
    "appSource_other": "Source · {{count}} lines — open the window to run it",
    "empty": "Empty.",
    "elements_one": "{{count}} element",
    "elements_other": "{{count}} elements",
    "more_one": "+{{count}} more",
    "more_other": "+{{count}} more",
    "unavailable": "Preview unavailable."
  },
  "shell": {
    "canvases": "Canvases",
    "goToCanvas": "Go to a canvas",
    "yourCanvases": "Your canvases",
    "noCanvas": "No canvas yet",
    "sharedWithYou": "Shared with you",
    "canvasActions": "Actions for {{name}}",
    "home": "Home",
    "breadcrumb": "Breadcrumb",
    "sidePanel": "Side panel",
    "resizeSidePanel": "Resize the side panel",
    "panels": "Canvas panels"
  },
  "userCorner": {
    "account": "Your account",
    "aiUsage": "AI usage",
    "inbox": "Inbox",
    "tutorials": "Tutorials",
    "signOut": "Sign out"
  },
  "dispatch": {
    "routing": "Finding the right task for “{{prompt}}”",
    "routingEllipsis": "Finding the right task for “{{prompt}}”…",
    "redirectFailed": "Could not start a new task",
    "runInParallel": "Run in parallel",
    "notice": {
      "steer": "Added to “{{title}}” — Nolë takes it into account as she works",
      "steerUntitled": "Added to an earlier task — Nolë takes it into account as she works",
      "answer": "Answered the question in “{{title}}”",
      "answerUntitled": "Answered the question in an earlier task",
      "continue": "Continued “{{title}}”",
      "continueUntitled": "Continued an earlier task",
      "newTask": "Started a new task"
    }
  },
  "dictation": {
    "memoRecording": "A voice memo is recording.",
    "sendFailed": "Couldn't send your request. It's in the Nolë panel."
  },
  "windowDock": {
    "openWindows": "Open windows",
    "window": "Window",
    "floating": "floating",
    "floatingTitle": "{{title}} · floating",
    "goToNode": "Go to the node",
    "goToNodeTitle": "Go to the node on the canvas",
    "windows": "Windows",
    "resize": "Resize the windows panel",
    "collapse": "Collapse the windows panel",
    "collapseTitle": "Collapse (])",
    "close": "Close {{title}}"
  },
  "noleRail": {
    "buttonTitle": "Nolë (N) · hold Alt to talk",
    "dismissFailed": "Couldn't dismiss the task.",
    "pillLabel": "{{status}}: {{request}}",
    "status": {
      "running": "Running",
      "waiting": "Needs your answer",
      "error": "Failed",
      "aborted": "Interrupted",
      "done": "Finished"
    },
    "moreTasks_one": "{{count}} more task",
    "moreTasks_other": "{{count}} more tasks",
    "dictation": {
      "sending": "Sending…",
      "handsFree": "Hands-free",
      "listening": "Nolë is listening",
      "lockedHint": "<kbd>Alt</kbd>/<kbd>Enter</kbd> sends · <kbd>Esc</kbd> cancels",
      "holdHint": "release sends · <kbd>Esc</kbd> cancels",
      "openingMic": "Opening the mic…",
      "speak": "Speak, Nolë is listening…",
      "click": "Click",
      "altClick": "Alt + Click",
      "toAttach": "to attach a node"
    }
  },
  "edgeMenu": {
    "title": "Edge actions",
    "color": "Color",
    "thickness": "Thickness",
    "strokeWidth": {
      "thin": "Thin",
      "thick": "Thick"
    },
    "appearance": "Appearance",
    "strokeStyle": {
      "solid": "Solid",
      "dashed": "Dashed",
      "dotted": "Dotted"
    },
    "addPoint": "Add point",
    "removeLabel": "Remove label",
    "source": "Source",
    "target": "Target",
    "node": "Node"
  },
  "addMenu": {
    "tabs": {
      "nodes": {
        "label": "Nodes",
        "searchPlaceholder": "Search a node"
      },
      "embeds": {
        "label": "Embeds",
        "searchPlaceholder": "Search a service"
      }
    },
    "groups": {
      "text": "Text",
      "dataApps": "Data & apps",
      "media": "Media"
    },
    "hints": {
      "title": "A heading for a zone",
      "blocknote": "A rich text document",
      "value": "A text, number or toggle",
      "link": "A web page preview",
      "table": "Rows and columns",
      "database": "Records with views",
      "board": "A kanban of cards",
      "app": "A mini app, in code",
      "image": "Upload or paste a picture",
      "file": "A PDF, Word, Excel or zip file",
      "audio": "A sound or a recording",
      "video": "Play a video file"
    },
    "addRowFailed": "Could not add a row",
    "customNodes": "Custom nodes",
    "customNode": "Custom node",
    "customNodeDescription": "Reusable custom node",
    "databaseRows": "Database rows",
    "newRow": "New row",
    "newRowDescription": "New row of this database",
    "services": "Services",
    "noServiceMatches": "No service matches “{{query}}”",
    "noNodeMatches": "No node matches “{{query}}”",
    "footer": {
      "navigate": "Navigate"
    },
    "manageTemplates": "Manage templates"
  },
  "databaseRow": {
    "detached": "Detached from {{title}}. It stays on the canvas.",
    "detachedUntitled": "Detached from the database. It stays on the canvas.",
    "detachFailed": "Could not detach the row",
    "detachFrom": "Detach from {{title}}",
    "detachFromUntitled": "Detach from the database",
    "added": "Added to {{title}}.",
    "addFailed": "Could not add the node",
    "addTo": "Add to {{title}}"
  },
  "embedStep": {
    "empty": "Paste a link first.",
    "invalid": "Enter a valid link.",
    "wrongService": "This doesn't look like a {{service}} link.",
    "linkLabel": "{{service}} link",
    "hint": "Paste the link from your browser or the Share menu."
  },
  "nodesMenu": {
    "blockActions": "Block actions",
    "selectionActions": "Selection actions",
    "layer": "Layer",
    "color": "Color",
    "editTemplate": "Edit template",
    "mergeImages_one": "Merge images ({{count}})",
    "mergeImages_other": "Merge images ({{count}})",
    "detachFromNole": "Detach from Nolë",
    "attachToNole": "Attach to Nolë",
    "altClick": "Alt + click",
    "bookmark": "Bookmark",
    "removeBookmarks_one": "Remove bookmarks ({{count}})",
    "removeBookmarks_other": "Remove bookmarks ({{count}})",
    "bookmarkSelection_one": "Bookmark selection ({{count}})",
    "bookmarkSelection_other": "Bookmark selection ({{count}})",
    "removeFromFrame": "Remove from frame",
    "removeFromFrameCount_one": "Remove from frame ({{count}})",
    "removeFromFrameCount_other": "Remove from frame ({{count}})",
    "moveToCanvas": "Move to another canvas"
  },
  "convert": {
    "extracting": "Filling the fields from the source…",
    "failed": "Could not convert the node",
    "database": "Database",
    "title": "Convert to custom node",
    "none": "No custom node yet",
    "create": "Create a custom node…"
  },
  "moveToCanvas": {
    "failed": "Could not move to this canvas",
    "title_one": "Move node to another canvas",
    "title_other": "Move {{count}} nodes to another canvas",
    "description": "Select a destination canvas, then confirm.",
    "loading": "Loading canvases…",
    "empty": "No other canvas available.",
    "moving": "Moving…",
    "confirm": "OK"
  },
  "canvasMenu": {
    "bookmarkHere": "Bookmark here"
  },
  "arrangeMenu": {
    "title": "Align & distribute"
  },
  "welcome": {
    "title": "Welcome to Nolënor",
    "description": "Three gestures to get you moving. You'll pick up the rest as you go.",
    "descriptionMobile": "A few things to know before you start.",
    "goToStep": "Go to step {{step}}: {{title}}",
    "stepOf": "Step {{step}} of {{total}}",
    "gotIt": "Got it",
    "next": "Next",
    "pointer": {
      "navigate": {
        "title": "Move around",
        "body": "Hold the <strong>middle mouse button</strong> and drag to pan. Hold <strong>Ctrl</strong> and scroll to zoom. On a trackpad, two fingers pan.",
        "scroll": "scroll"
      },
      "open": {
        "title": "Open a node",
        "body": "<strong>Double-click</strong> a node to open it in a window. Select it to reveal its toolbar, then hit the pencil to edit in place.",
        "hint": "Double-click"
      },
      "menu": {
        "title": "Right-click for the rest",
        "body": "<strong>Right-click the canvas</strong> to add a node. <strong>Right-click a node or a link</strong> to recolor, duplicate or delete it.",
        "hint": "Right-click"
      }
    },
    "touch": {
      "navigate": {
        "title": "Move around",
        "body": "Drag <strong>one finger</strong> to pan. <strong>Pinch</strong> to zoom."
      },
      "open": {
        "title": "Open a node",
        "body": "<strong>Double-tap</strong> a node to open it full screen."
      },
      "menu": {
        "title": "Add and edit",
        "body": "Tap <strong>+</strong> in the bottom bar to add a node. Select a node to duplicate or delete it from that same bar."
      }
    },
    "desktopFirst": {
      "title": "Best on a computer",
      "body": "Nolënor is designed for a <strong>large screen</strong>. On your phone, this is the companion view: browse your canvases, review your nodes and ask Nolë on the go. For the full experience, open Nolënor on a computer."
    }
  },
  "onboarding": {
    "promptPrefix": "Ask Nolë to ",
    "prompt": "Ask Nolë to {{task}}",
    "hints": {
      "appPrototype": {
        "label": "App prototype",
        "suffix": "turn screenshots into a mobile app prototype, with one editable node per screen."
      },
      "imageGeneration": {
        "label": "Image generation",
        "suffix": "create several variations of an image, exploring different styles and compositions."
      },
      "businessResearch": {
        "label": "Business research",
        "suffix": "build a lean canvas for a business idea, researching its market, competitors, and pricing."
      },
      "csvVisualization": {
        "label": "CSV visualization",
        "suffix": "analyze a CSV and visualize the most important insights."
      },
      "projectWorkspace": {
        "label": "Project workspace",
        "suffix": "turn notes and files into a structured project workspace, with a summary, key tasks, and next steps."
      },
      "productLaunch": {
        "label": "Product launch",
        "suffix": "plan a product launch, from positioning to finding the first 100 customers."
      },
      "decisionSupport": {
        "label": "Decision support",
        "suffix": "compare options, research what matters, and help me decide what to do next."
      },
      "meetingNotes": {
        "label": "Meeting notes",
        "suffix": "turn meeting notes into clear decisions, owners, and next steps."
      }
    },
    "ideas": "Some ideas to get you started",
    "dictateTitle": "Dictate (or hold Ctrl+Alt)",
    "stopDictation": "Stop dictation",
    "startDictation": "Start dictation",
    "uploading": "Uploading — send available when done",
    "holdToDictate": "Hold Ctrl+Alt to dictate",
    "tapToDictate": "Tap the mic to dictate, tap again to stop",
    "listening": "Listening…",
    "transcribing": "Transcription…",
    "heading": "What’s on your mind?",
    "subheading": "A project, notes, documents… Bring them here. Nolë helps you make sense of it all.",
    "startFromScratch": "Start from scratch"
  },
  "dropzone": {
    "adding_one": "Adding {{done}}/{{count}} file…",
    "adding_other": "Adding {{done}}/{{count}} files…",
    "readyWithFailures_one": "{{ready}}/{{count}} file ready ({{failed}} failed)",
    "readyWithFailures_other": "{{ready}}/{{count}} files ready ({{failed}} failed)",
    "ready_one": "{{count}} file ready on the canvas",
    "ready_other": "{{count}} files ready on the canvas",
    "moreMobile": "More files? <browse>Browse files</browse>.",
    "moreDesktop": "More files? Drop them here or <browse>browse</browse>.",
    "upload": "Upload files",
    "formats": "PDF, images, audio, links, .csv, .md, .txt",
    "dropHere": "Drop files here (PDF, images, audio, links, .csv, .md, .txt)",
    "orBrowse": "or <browse>browse your files</browse>"
  },
  "targetDelta": {
    "label": "This node is about {{screens}} screens away — the arrow points toward it"
  },
  "selectionResizer": {
    "saveFailed": "Could not save the selection size"
  },
  "presence": {
    "hasItOpen": "has it open",
    "selectedIt": "selected it"
  }
}
